module.exports = __webpack_public_path__ + "img/Bear45.652d73c4.jpg";